import { useEffect, useRef } from 'react';

const useCallbackDebounce = (
  callback: any,
  delay: number,
  deps: React.DependencyList,
) => {
  const cbRef = useRef();

  useEffect(() => {
    cbRef.current = callback;
  }, [callback]);

  useEffect(() => {
    const handler = setTimeout(() => {
      //@ts-ignore
      cbRef.current();
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, deps);

  return () => {};
};
export default useCallbackDebounce;
